export default {
  name: "DownloadSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};